// src/pages/ModelHome.tsx
import "../App.css"; // ensure the BotFather-like styles are available on this page
import { Helmet } from "react-helmet";
import { useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { models } from "../models";

export default function ModelHome() {
  const { modelName } = useParams();
  const model = useMemo(() => models[modelName ?? ""], [modelName]);

  const [agreed, setAgreed] = useState<boolean>(
    () => localStorage.getItem("agreedToLicense") === "true"
  );

  if (!model) return <div style={{ padding: 24 }}>Model not found</div>;

  return (
    <>
      <Helmet>
        <title>{model.fullName} | Albums</title>
      </Helmet>

      <main className="home-screen">
        <div className="safe-top-spacer" />

        {/* Hero */}
        <section className="hero">
          <img className="hero-avatar" src={model.avatar} alt={model.fullName} />
          <h1 className="hero-title">{model.fullName}</h1>
          {!!model.welcomeMessage && <p className="hero-sub">{model.welcomeMessage}</p>}
        </section>

        {/* Age-gate lives on the home page */}
        {!agreed && (
          <div className="agreement-container" style={{ background: "transparent", padding: 0 }}>
            <div className="agreement-card">
              <div className="agreement-icon">🛡️</div>
              <h3>Age Verification & Disclaimer</h3>
              <p>By continuing, you confirm that:</p>
              <ul>
                <li>You are 18 years of age or older</li>
                <li>
                  You agree to our{" "}
                  <a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a>
                </li>
                <li>
                  You agree to our{" "}
                  <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                </li>
              </ul>
              <button
                className="agree-button"
                onClick={() => {
                  localStorage.setItem("agreedToLicense", "true");
                  setAgreed(true);
                }}
              >
                I Agree
              </button>
            </div>
          </div>
        )}

        {/* Albums list */}
        <h3 className="list-title">My albums</h3>
        <div className="section-card">
        <div className="album-grid">
            {model.albums.map((a: any) => (
            <Link key={a.id} className="album-card" to={`/${model.id}/a/${a.id}`}>
                <img className="album-thumb" src={a.cover ?? model.cover} alt={a.title} />
                <div className="album-caption">
                <div className="album-title">{a.title}</div>
                <div className="album-count">{a.totalLevels} photos</div>
                </div>
            </Link>
            ))}
        </div>
        </div>

        <div className="toolbar-spacer" aria-hidden="true" />
      </main>
    </>
  );
}
